// The location bar under the panel's header, on a brand with several locations (D4). Wording from the Amigo design's
// copy sheet (Location bar).
export default {
  label: 'Ubicación',
  all_one: 'Todas las {{count}} ubicaciones',
  all_other: 'Todas las {{count}} ubicaciones',
};
